import { useMutation } from "@tanstack/react-query";
import client from './config';

const createPoll = async (Content) => {
    const response = await client.post('/api/generate-poll', Content);
    return response.data;
};

const useCreatePoll = () => {
    return useMutation({
        mutationFn: createPoll,
    });
};

export { useCreatePoll }